import { render, staticRenderFns } from "./WorkerDocuments.vue?vue&type=template&id=78d0db90&scoped=true&"
import script from "./WorkerDocuments.vue?vue&type=script&lang=js&"
export * from "./WorkerDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d0db90",
  null
  
)

export default component.exports